import _ from 'underscore';

type HotelOperator = {
    id: number;
    name: string;
};

export const OPERATOR_FILTER_MAP = {
    THROUGH: 'through',
    THROUGH_AND_TRAVELATA: 'throughAndTravelata',
    DROP: 'drop'
} as const;

type ValueOf<T> = T[keyof T];

type FilterOperatorsParams = {
    allHotelOperators: HotelOperator[];
    operatorFilterIds: number[];
    filterType: ValueOf<typeof OPERATOR_FILTER_MAP>;
    travelataId: number;
};

export const OperatorFilterService = {
    filterOperators({
         allHotelOperators,
         operatorFilterIds = [],
         filterType,
         travelataId
    }: FilterOperatorsParams): HotelOperator[] {
        if (filterType === OPERATOR_FILTER_MAP.DROP) {
            return [];
        }

        const filteredOperators = operatorFilterIds.length
            ? allHotelOperators.filter(operator => operatorFilterIds.includes(operator.id))
            : [];

        if (filterType === OPERATOR_FILTER_MAP.THROUGH_AND_TRAVELATA) {
            const travelataOperator: HotelOperator = {
                id: travelataId,
                name: 'Travelata'
            };
            if (filteredOperators.length > 0) {
                return _.uniq([...filteredOperators, travelataOperator], operator => operator.id);
            }
        }

        return operatorFilterIds.length
            ? allHotelOperators.filter(operator => operatorFilterIds.includes(operator.id))
            : [];
    }
};